export default __webpack_public_path__ + "static/media/chime.3b3cc5bf.mp3";